import React from 'react';

type Props = {
    actionId            : string
    hasAccess           : boolean
    fadeTime            : number
    close               : callback
}

export default function ActionApplied(props:Props) {

    const openAction = () => {
        if (!props.hasAccess) {
            return
        }

        gd.goTo('action/{0}'.f(props.actionId))
        props.close()
    }

    const style : style = {
        transition: "opacity " + props.fadeTime + "s"
    }

    return (
        <div className  = "notification h-100-percent info"
             style      = {style}
        >
            <div className  = "flex-row-left-center"
                 onClick    = {openAction}
            >
                <div className="left-indicator"/>
                <div className="i5-play ui5-color-action fs-15 m-l-3"/>
                <div className="message ui5-txt-not-important-small m-l-10">
                    Action applied
                </div>
            </div>

            <div className  = "close i5-delete"
                 onClick    = {props.close}
            />
        </div>
    )

}
